<template>
    <div class="pt-5 pb-3 px-4">
        <img :src="logo_fanosa" class="logo pb-5" alt="Logo Fanosa">
        <img :src="dataUrl" class="user" alt="User profile photo">
        <h4 class="center blueText"> ¡Hola, {{name | split }}! </h4>
        <h4 class="center grayText"> Estás en el Administrador </h4>
    </div>
</template>

<script>
import profile from '../assets/user.png';
import logo from '../assets/logo.png';
import userService from '../services/user.service'

export default {
    name: 'Header',
    props:{
        name: {
            required: true
        }
    },
    data() {
        return {
            user: profile,
            logo_fanosa: logo,
        }
    },
  computed:{
    token() {
      return this.$store.getters['userService/getToken'];
    },
    identity() { 
      return this.$store.getters['userService/getIdentity'];
    },dataUrl(){
         let token = userService.getToken();
         let identity = userService.decode(token);
        return 'data:img/jpeg;base64,' + btoa(
            new Uint8Array(identity.img.data)
            .reduce((data, byte) => data + String.fromCharCode(byte), '')
        );}
  },
    filters:{
        split: (value) => {
            if (!value) return '';
            value = value.toString();
            let splitStr = value.toLowerCase().split(' ');
            let len = splitStr.length
            let i;

            for ( i = 0; i < len; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
            }
            let nameCap = splitStr.join(' '); 
            let newName = nameCap.split(' ').slice(0, -2).join(' ')

            return newName;
        },
    }
}
</script>

<style scoped>
.logo{
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
    display: block;
}
.blueText{
    font-family: 'FuturaPTBold';
    color: #005cc3;
}
.grayText{
    font-family: 'FuturaPTMedium';
    font-size: 1.2rem;
    color: #bcbcbc;
}
</style>

